export default "__VITE_ASSET__BtlmUYKv__"